/* eslint-disable */
import React, {  Fragment } from 'react';

import { Link } from "react-router-dom";
import { Menu } from '@headlessui/react'
const auth_key = localStorage.getItem('auth_key');
const funnelHost = process.env.REACT_APP_PEOPLE_URL;


export default function HeaderNav2({ new_Channel, noAuth }) {
    return (
        <ul className="navbar-nav bg-gradient-primary1  sidebar sidebar-dark accordion" id="accordionSidebar">
            <Link className="sidebar-brand d-flex align-items-center justify-content-center">
                <div className="sidebar-brand-icon"><i className="fas fa-sitemap"></i></div>
                <div className="sidebar-brand-text mx-3"> Oiomni</div>
            </Link>

            <div className='sidebar-heading'> <i className="fa-solid fa-list-check"></i> All Trigger </div>
            <hr className="sidebar-divider" />
            <li className="nav-item">
                <button type='button' className="nav-link" onClick={() => new_Channel("on_message")}>
                    <i className="fa-solid fa-comments"></i>
                    <span>On Message</span>
                </button>
            </li>
            <li className="nav-item">
                <button type='button' className="nav-link" onClick={() => new_Channel("on_attribute")}>
                    <i className="fa-solid fa-user-pen"></i><span>On Attribute Change</span>
                </button>
            </li>
            <li className="nav-item">
                <button type='button' className="nav-link" onClick={() => new_Channel("agent_assign")}>
                    <i className="fa-solid fa-user-check"></i><span>On Agent Assign</span>
                </button>
            </li>
            <li className="nav-item">
                <button type='button' className="nav-link" onClick={() => new_Channel("on_webhook")}>
                    <i className="fa-solid fa-sliders"></i><span>On Webhhok</span>
                </button>
            </li>

            <li className="nav-item">
                <button type='button' className="nav-link" onClick={() => new_Channel("on_new_funnel")}>
                    <i className="fa-solid fa-sliders"></i><span>On Funnel</span>
                </button>
            </li>



            
            {/* ----------------------------------------- */}

            <Menu>
                <Menu.Button as='div' className="setting_menu1"> <i className=" icon_box_set fa-solid fa-gear"></i> <span> Drip </span> <i className="arro_right fa-solid fa-chevron-right"></i></Menu.Button>
                <Menu.Items>
                    <ul className="as_new1_new p-0">
                        <Menu.Item>
                            <Fragment>
                                <Menu as='div' className="setting_menu_ul">
                                    <Menu.Button as='div' className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <button type='button' className="nav-link" onClick={() => new_Channel("all_attrtibute")}>
                                            <i className="icon_box_set fa-solid fa-file-lines"></i><span>Attribute</span>
                                        </button>
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left flex setting_menu_li items-center outline-none ">
                                        <button type='button' className="nav-link" onClick={() => new_Channel("on_spreedsheet")}>
                                            <i className="icon_box_set fa-solid fa-file-lines"></i><span>Spreedsheet</span>
                                        </button>
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <button type='button' className="nav-link" onClick={() => new_Channel("on_funnel")}>
                                            <i className="icon_box_set fa-solid fa-filter"></i><span>Funnel</span>
                                        </button>
                                    </Menu.Button>

                                    <Menu.Button as='div' className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <button type='button' className="nav-link" onClick={() => new_Channel("phonebook")}>
                                            <i className="icon_box_set fa-solid fa-file-lines"></i><span>Phonebook</span>
                                        </button>
                                    </Menu.Button>
                                </Menu>
                            </Fragment>
                        </Menu.Item>
                    </ul>
                </Menu.Items>
            </Menu>

            <Menu>
                <Menu.Button as='div' className="setting_menu1"> <i className=" icon_box_set fa-solid fa-gear"></i> <span> Settings </span> <i className="arro_right fa-solid fa-chevron-right"></i></Menu.Button>
                <Menu.Items>
                    <ul className="as_new1_new p-0">
                        <Menu.Item>
                            <Fragment>
                                <Menu as='div' className="setting_menu_ul">
                                    <Menu.Button as='div' className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <Link to="/all_flow" className="nav-link"> <i className="icon_box_set fa-solid fa-list-check"></i>  <span> Bot List </span></Link>
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left flex setting_menu_li items-center outline-none ">
                                        <Link target="_blank" className="nav-link" to={funnelHost + "/loginAs/" + auth_key}>
                                            <i className="icon_box_set fa-solid fa-people-group"></i><span className="nav-text">People</span>
                                        </Link>
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <Link to="/webhook_setup" className="nav-link"> <i className="icon_box_set fa-solid fa-sliders"></i><span> Bot Webhook </span></Link>
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <Link to="/profile" className="nav-link"> <i className="icon_box_set fa-regular fa-address-card"></i> <span> Profile</span></Link>
                                    </Menu.Button>
                                </Menu>
                            </Fragment>
                        </Menu.Item>
                    </ul>
                </Menu.Items>
            </Menu>

            <Menu>
                <Menu.Button as='div' className="setting_menu1"><i className="icon_box_set fa-solid fa-hourglass-start"></i> <span> Coming Soon </span>  <i className="arro_right fa-solid fa-chevron-right"></i></Menu.Button>
                <Menu.Items>
                    <ul className="as_new1_new p-0">
                        <Menu.Item>
                            <Fragment>
                                <Menu as='div' className="setting_menu_ul">
                                    <Menu.Button as='div' className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <Link to="/all_flow" className="nav-link">
                                            <i className="icon_box_set fa-solid fa-handshake"></i> <span> Deal Converstion  </span>
                                        </Link>
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left flex setting_menu_li items-center outline-none ">
                                        <Link to="/all_flow" className="nav-link">
                                            <i className="icon_box_set fa-solid fa-volume-high"></i> <span> On Voice Call </span>
                                        </Link>
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <Link to="/webhook_setup" className="nav-link">  <i className="icon_box_set fa-solid fa-users-line"></i>
                                            <span> Spreed Sheet </span>
                                        </Link>
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <Link to="/profile" className="nav-link"> <i className="icon_box_set fa-solid fa-handshake-slash"></i>
                                            <span> On Close Converstion </span>
                                        </Link>
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left setting_menu_li flex items-center outline-none ">
                                        <Link to="/profile" className="nav-link"> <i className="icon_box_set fa-brands fa-threads"></i>
                                            <span> Ads </span>
                                        </Link>
                                    </Menu.Button>
                                </Menu>
                            </Fragment>
                        </Menu.Item>
                    </ul>
                </Menu.Items>
            </Menu>

            <li className="nav-item">
                <button onClick={noAuth} className="nav-link">
                    <i className="fas fa-power-off"></i>
                    <span> Logout </span>
                </button>
            </li>

            {/* 
            <Menu>
                <Menu.Button>New Funnel Tri</Menu.Button>
                <Menu.Items>
                    <ul className="as_new1">
                        <Menu.Item>
                            <Fragment>
                                <Menu>
                                    <Menu.Button className="w-full text-left flex items-center outline-none as_btn_new"
                                        onClick={() => new_Channel("on_new_funnel")}>
                                        New In Funnel
                                    </Menu.Button>
                                    <Menu.Button className="w-full text-left flex items-center outline-none as_btn_new"
                                        onClick={() => new_Channel("on_edit_funnel")}>
                                        Edit In Funnel
                                    </Menu.Button>
                                </Menu>
                            </Fragment>
                        </Menu.Item>
                    </ul>
                </Menu.Items>
            </Menu>
            */}
        </ul>
    )
}